import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ConfigService } from 'src/app/_services/config.service';

@Component({
	standalone: false,
	templateUrl: '404.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		`
			:host {
				display: block;
			}

			.notfound-container {
				min-height: 100vh;
				display: flex;
				align-items: center;
				justify-content: center;
				background: var(--kcs-background, linear-gradient(147.38deg, #06b6d4 0%, #155e75 100%));
				padding: 24px;
			}

			.error-content {
				position: relative;
				background: var(--kcs-surface-card, #ffffff);
				border: 1px solid var(--kcs-surface-border, #e2e8f0);
				border-radius: 1rem;
				padding: 48px 44px 40px;
				max-width: 560px;
				width: 100%;
				text-align: center;
				box-shadow: 0 24px 60px rgba(15, 23, 42, 0.28);
				animation: slideUp 0.5s ease-out;
				overflow: hidden;
			}

			.error-content::before {
				content: '';
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				height: 5px;
				background: var(--kcs-primary, #408ee2);
			}

			@keyframes slideUp {
				from {
					opacity: 0;
					transform: translateY(24px);
				}
				to {
					opacity: 1;
					transform: translateY(0);
				}
			}

			.brand-logo {
				max-height: 60px;
				max-width: 220px;
				object-fit: contain;
				margin-bottom: 28px;
			}

			.error-code {
				font-size: 88px;
				font-weight: 800;
				line-height: 1;
				color: var(--kcs-primary, #408ee2);
				letter-spacing: -2px;
				margin-bottom: 8px;
			}

			.error-title {
				font-size: 24px;
				font-weight: 700;
				color: var(--kcs-text, #1e293b);
				margin-bottom: 12px;
				line-height: 1.25;
			}

			.error-message {
				font-size: 15px;
				color: var(--kcs-secondary-text, #64748b);
				margin-bottom: 28px;
				line-height: 1.6;
			}

			.action-buttons {
				display: flex;
				gap: 12px;
				justify-content: center;
				flex-wrap: wrap;
			}

			.kcs-btn {
				display: inline-flex;
				align-items: center;
				justify-content: center;
				gap: 8px;
				padding: 11px 22px;
				border-radius: 0.5rem;
				font-weight: 600;
				font-size: 14px;
				border: 1px solid transparent;
				cursor: pointer;
				transition: all var(--transition-duration, 0.2s) ease;
				min-width: 150px;
			}

			.kcs-btn-primary {
				background: var(--kcs-primary, #408ee2);
				color: var(--kcs-primary-text, #fff);
			}

			.kcs-btn-primary:hover {
				background: var(--kcs-primary-hover, #007bff);
				color: var(--kcs-primary-hover-text, #fff);
				transform: translateY(-2px);
			}

			.kcs-btn-secondary {
				background: transparent;
				color: var(--kcs-secondary-text, #64748b);
				border-color: var(--kcs-surface-border, #e2e8f0);
			}

			.kcs-btn-secondary:hover {
				background: var(--kcs-surface-ground, #f1f5f9);
				transform: translateY(-2px);
			}

			@media (max-width: 576px) {
				.error-content {
					padding: 36px 24px 28px;
				}

				.error-code {
					font-size: 68px;
				}

				.action-buttons {
					flex-direction: column;
					align-items: stretch;
				}

				.kcs-btn {
					width: 100%;
				}
			}
		`,
	],
})
export class P404Component implements OnInit {
	companyLogo: string | null = null;
	companyName: string = '';

	constructor(private router: Router, private location: Location, private configService: ConfigService) {}

	ngOnInit() {
		const tema = localStorage.getItem('theme') || 'default';
		document.documentElement.setAttribute('kcs-theme', tema);

		const logo = this.configService.getCompanyLogo();
		this.companyLogo = logo && logo.startsWith('data:') ? logo : null;
		this.companyName = localStorage.getItem('def_company_name') || '';
	}

	goHome() {
		this.router.navigate(['/']);
	}

	goBack() {
		this.location.back();
	}
}
